import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Skeleton } from "../loading";

/**
 * 富文本編輯器的對外入口。
 *
 * 編輯器本體（RichEditorCore，Tiptap＋ProseMirror）約 130 KB（gzip），只有表單與工項頁用得到，
 * 所以用 React.lazy 拆成獨立的 chunk：其他頁面不必下載，用到時才載入，
 * 載入期間先畫一塊跟編輯器同高的骨架。對外介面與 RichEditorCore 完全相同。
 */
const RichEditorCore = lazy(() => import("./RichEditorCore"));

function RichEditor(props) {
  const { minHeight } = props;
  return (
    <Suspense
      fallback={
        <Box role="status" aria-label="編輯器載入中" sx={{ border: "1px solid var(--line-control)", borderRadius: "var(--radius-sm)", p: 1 }}>
          <Skeleton h={36} radius="var(--radius-sm)" sx={{ mb: 1 }} />
          <Skeleton h={minHeight} radius="var(--radius-sm)" />
        </Box>
      }
    >
      <RichEditorCore {...props} />
    </Suspense>
  );
}

RichEditor.propTypes = {
  id: PropTypes.string,
  html: PropTypes.string,
  placeholder: PropTypes.string,
  minHeight: PropTypes.number,
  onChange: PropTypes.func,
  color: PropTypes.string,
  lineHeight: PropTypes.string,
};

RichEditor.defaultProps = {
  id: undefined,
  html: "",
  placeholder: "",
  minHeight: 120,
  onChange: null,
  color: "var(--ink)",
  lineHeight: "var(--t-body-lh)",
};

export default RichEditor;
